module.exports = __webpack_public_path__ + "static/media/img_0.4dae1041.png";